import React, { cloneElement } from 'react';
import { ListItem, StyledHiddenBullet, StyledIcon, StyledList } from './index.styles.js';
import {} from '../icon/index.js';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const TextListItem = ({ children, value, role, size, icon, variant }) => {
    const iconSizeMapping = size === 'md' ? 's' : 'xs';
    return (React.createElement(ListItem, { value: value, role: role },
        variant === 'bullet' && (React.createElement(StyledHiddenBullet, { "aria-hidden": true }, "\u203A")),
        icon && size && React.createElement(StyledIcon, { name: icon, size: iconSizeMapping }),
        children));
};
const isTextListItemModified = (props) => {
    return props.variant === 'icon' || props.variant === 'bullet';
};
export const TextList = (props) => {
    const listType = ['no-marker', 'bullet', 'icon'].includes(props.variant)
        ? 'ul'
        : 'ol';
    const modifiedChildren = React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {
                variant: props.variant,
                icon: props.icon,
                size: props.size
            });
        }
        return child;
    });
    const a11yProps = pickA11yProps(props);
    const dataProps = pickDataProps(props);
    return (React.createElement(StyledList, { as: listType, ...a11yProps, ...dataProps, size: props.size, variant: props.variant, className: props.className, margin: props.margin }, isTextListItemModified(props) ? modifiedChildren : props.children));
};
//# sourceMappingURL=index.js.map